import { getStore } from "../store/store";
import type MailFavoritesViewState from "../store/schema/FavoritesViewState";
import type { AccountKey } from "owa-client-types";

export default function getMailFavoritesViewState(accountKey: AccountKey): MailFavoritesViewState | undefined {
    return getStore().mailFavoritesViewState.get(accountKey);
}
